import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  FilterType
} from '@globaleris/ui.library'
import { getCustomerDomain } from '../../../../redux'
import { ObjectionsModel } from '../../../invoicesPage/invoicesPage.Model'
import { Save } from  '@material-ui/icons'

interface Props {
  data: ObjectionsModel[]
  onResolveObjections?: (ids: number[]) => void
}

export const ResolveObjectionsTable: React.FC<Props> = ({ data, onResolveObjections  }) => {
  const [t] = useTranslation(['globalerisLibrary', 'tasks', 'enums'])

  const columns: DataTableColumn[] = [
    {
      name: 'id',
      display: false
    },
    {
      name: 'criticality',
      label: t('tasks:components.resolveObjectionsTable.columns.criticality'),
      type: DataType.TEXT
    },
    {
      name: 'description',
      label: t('tasks:components.resolveObjectionsTable.columns.description'),
      type: DataType.TEXT
    }
  ]

  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: false,
    filterType: FilterType.ADVANCED,
    elevation: 0,
    download: false,
    canEdit: false,
    canDelete: false,
    canInsert: false,
    pagination: true,
    analytics: {
      customer: getCustomerDomain(),
      view: t('tasks:components.resolveObjectionsTable.title')
    },
    selectableRows: true,
    selectToolbarCustomActions: [
      {
        icon: <Save />,
        tooltip: t('tasks:components.resolveObjectionsTable.actions.resolve'),
        onClick: (selectedRows) => {
          const selectedIds = selectedRows.map((row: any) => row.id)
          onResolveObjections?.(selectedIds)
        }
      }
    ]
  }

  return (
    <DataTable
      data={data}
      columns={columns}
      options={options}
    />
  )
}
